import { cn } from "../../helpers"

const mobile = (isFixedOnMobile?: boolean, isCentered?: boolean, hasGradientOverlay?: boolean) =>
  cn(
    "lg:hidden flex gap-2 justify-center",
    isFixedOnMobile
      ? "fixed z-40 bottom-0 left-0 right-0 w-full px-4 pt-3 pb-3 dock-pb-safe"
      : "static",
    isCentered ? "justify-center items-center flex-col" : "",
    hasGradientOverlay
      ? "bg-gradient-to-b from-transparent to-white"
      : isFixedOnMobile
      ? "border-t border-t-neutral-200 bg-white"
      : ""
  )

const wrapper = (
  hasGradientOverlay?: boolean,
  isPrepackagePage?: boolean,
  isSingleButton?: boolean,
  isPrepackageOpaque?: boolean
) =>
  cn(
    "fixed z-40 bottom-0 left-0 right-0 w-full border-t border-t-neutral-200 bg-white px-12 pt-3 dock-pb-safe hidden lg:block",
    hasGradientOverlay
      ? "bg-gradient-to-b from-transparent to-white"
      : "border-t border-t-neutral-200 bg-white",
    isPrepackagePage
      ? isPrepackageOpaque
        ? "bg-transparent border-t border-t-neutral-200 bg-white "
        : "bg-transparent border-none "
      : "",
    isSingleButton ? "bg-white  items-center mx-auto " : ""
  )

const innerWrapper = cn(
  "mx-auto flex w-full sm:w-[24rem] md:w-[36.750rem] items-center justify-center gap-3"
)

export { innerWrapper, mobile, wrapper }
